import { Link as ReactLink } from "react-router-dom";
import React, { useMemo } from "react";
import ClientLink from "./ClientLink";
import { Button } from "reactstrap";
import { useSelector } from "react-redux";


const NodeModal = ({ isOpen, onClose, data, clientId, structure, memberValues }) => {
  const accountTypes = useSelector((state) => state.tradingAccountReducer.accountTypes);
  const getAccountTypeTitle = (id, accountTypes) => {
    return accountTypes?.find((type) => type._id === id)?.title || "Unknown";
  };
  const getHighest = (value) => {
    let rebate = 0,
      commission = 0;
    Object.keys(value).forEach((k) => {
      if (value[k].rebate && value[k].rebate > rebate) rebate = value[k].rebate;
      if (value[k].commission && value[k].commission > commission)
        commission = value[k].commission;
    });
    return {
      commission,
      rebate
    };
  };

  const getColorByAccountType = (accountTypeId) => {
    if (!accountTypeId) return "#7f8c8d";
  
    let hash = 0;
    for (let i = 0; i < accountTypeId.length; i++) {
      hash = accountTypeId.charCodeAt(i) + ((hash << 5) - hash);
    }
  
    const hue = Math.abs(hash) % 360;
  
    const saturation = 65;
    const lightness = 55;
  
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  };

  
  function getRebateCommission() {
    if (!data.children) return [];
    const model =
      structure?.members &&
      structure?.members
        ?.find((m) => m.customerId._id === data._id)
        ?.values.map((value) => ({
          label: value.accountTypeName,
          rebate: getHighest(value).rebate,
          commission: getHighest(value).commission
        }));

    return model || [];
  }

  const tradingAccounts = useMemo(() => {
    if (!data?.fx) return [];
    return [...data.fx.liveAcc, ...data.fx.demoAcc];
  }, [data]);

  if (!isOpen || !data) return null;


  return (
    <>
      <div className="node-backdrop" onClick={onClose}></div>
      <div className="node-modal">
        <div className="info">
          <h4 className="mb-0">
            <ClientLink id={data.id} firstName={`${data.firstName} ${data.lastName}`} redirect={true} />
          </h4>
          <small>{data.email}</small>
          {/* {(!data.fx || (data.fx && tradingAccounts.length === 0)) &&
            <div className="nowrap mt-2">
              <ReactLink
                color="primary"
                className="highlight"
                to="#">
                No Accounts linked
              </ReactLink>
            </div>
          } */}
          {memberValues?.values?.length ? (
            <div className="mt-2">
              {memberValues.values.map((v, idx) => {
                const title = getAccountTypeTitle(v.accountTypeId, accountTypes);
                const color = getColorByAccountType(v.accountTypeId);
                return (
                  <div
                    key={v.accountTypeId || idx}
                    className="d-flex align-items-center mb-2 gap-3"
                  >
                    <span style={{minWidth: "75px"}}>{title}</span>
                    <span
                      style={{
                        backgroundColor: color,
                        color: "#fff",
                        padding: "2px 8px",
                        borderRadius: "10px",
                        fontSize: "12px",
                      }}
                    >
                      Rebate: {v.rebate}
                    </span>
                    <span
                      style={{
                        backgroundColor: color,
                        color: "#fff",
                        padding: "2px 8px",
                        borderRadius: "10px",
                        fontSize: "12px",
                      }}
                    >
                      Commission: {v.commission}
                    </span>
                  </div>
                );
              })}
            </div>
          ) : (
            <p>-</p>
          )}

          {tradingAccounts && tradingAccounts.length > 0 && (
            <>
              <div className="nowrap mt-2">
                <ReactLink
                  color="primary"
                  className="highlight"
                  to="#">
                  Account
                </ReactLink>
              </div>
              <small>{tradingAccounts.join(", ")}</small>
            </>
          )}
          
        </div>
        <Button color="primary" onClick={onClose}>Close</Button>
      </div>
    </>
  );
};

export default NodeModal;
